module.exports = __webpack_public_path__ + "static/media/Rafael_Castaneda_Fernandez.7b171f68.jpg";